import { render, staticRenderFns } from "./ConversionesActivas.vue?vue&type=template&id=3b54ca0f&scoped=true"
import script from "./ConversionesActivas.vue?vue&type=script&lang=js"
export * from "./ConversionesActivas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54ca0f",
  null
  
)

export default component.exports